import { Component, inject, Input, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PlaystoreInfoModalComponent } from '../playstore-info-modal/playstore-info-modal.component';
import { PrivacyPolicyModalComponent } from '../privacy-policy/privacy-policy-modal/privacy-policy-modal.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  @Input() isLogin: boolean;
  readonly year = new Date().getFullYear();
  @ViewChild('playStoreModal')
  playstoreInfoModalComponent!: PlaystoreInfoModalComponent;
  @ViewChild('privacyPolicyModal')
  privacyPolicyModalComponent!: PrivacyPolicyModalComponent;
  private modalService = inject(NgbModal);

  openModal(modal: TemplateRef<any>, windowClass: string = '') {
    this.modalService.open(modal, {
      windowClass: `project-modal ${windowClass}`,
      centered: true,
      backdropClass: 'primary-backdrop',
    });
  }
}
